module.exports = __webpack_public_path__ + "img/block-1920.7ed02c16.jpg";